import { isAxiosError } from 'axios'

import type {
  ApiV1AccountLoginPostRequest,
  ApiV1UserIdChangePasswordPutRequest,
  ApiV1UserIdPutRequest,
  ProfileApi,
} from '../generated'
import { createAPISlice } from './createAPISlice'
import i18n from '~/i18n'

export default function createUserApis(userApi: ProfileApi) {
  return createAPISlice(
    {
      getUser: async (id: string) => {
        return await userApi.apiV1UserIdGet(id)
      },
      updateUser: async (id: string, params: ApiV1UserIdPutRequest) => {
        return await userApi.apiV1UserIdPut(id, params)
      },
      changeEmail: async (id: string, params: ApiV1AccountLoginPostRequest) => {
        return await userApi.apiV1UserIdChangeEmailPut(id, params)
      },
      changePassword: async (
        id: string,
        params: ApiV1UserIdChangePasswordPutRequest,
      ) => {
        return await userApi.apiV1UserIdChangePasswordPut(id, params)
      },
    },
    {
      getUser: (error) => {
        if (isAxiosError(error) && error.status === 400) {
          return {
            message: i18n.t('errors.API._UserNotFound'),
          }
        }
      },
      updateUser: (error) => {
        if (isAxiosError(error) && error.status === 400) {
          return {
            message: i18n.t('errors.API._UserNotFound'),
          }
        }
      },
      changeEmail: (error) => {
        if (isAxiosError(error) && error.response) {
          if (error.status === 400) {
            return {
              fieldErrors: {
                email: i18n.t('errors.API.changeEmail.emailAlreadyExists'),
              },
            }
          } else if (error.status === 403) {
            return {
              fieldErrors: {
                password: i18n.t('errors.API._InvalidPassword'),
              },
            }
          } else if (error.status === 404) {
            return {
              message: i18n.t('errors.API._UserNotFound'),
            }
          }
        }
      },
      changePassword: (error) => {
        if (isAxiosError(error) && error.response) {
          if (error.status === 403) {
            return {
              fieldErrors: {
                oldPassword: i18n.t('errors.API._InvalidPassword'),
              },
            }
          } else if (error.status === 404) {
            return {
              message: i18n.t('errors.API._UserNotFound'),
            }
          }
        }
      },
    },
  )
}
